module.exports = __webpack_public_path__ + "static/laudsgn3-69ceb07ac63389f98c312bc91412540a.jpg";